const MockData = {
  serverName: "My Test Server 1",
  url: "mytestserver1.com",
  traffics: [
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-02T08:37:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-02T08:55:35.417+00:00",
    },
    {
      path: "/signup",
      host: "mytestserver1.com",
      createdAt: "2023-04-02T11:19:35.417+00:00",
    },
    {
      path: "/signup",
      host: "mytestserver1.com",
      createdAt: "2023-04-15T11:09:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-15T09:19:35.417+00:00",
    },
    {
      path: "/docs",
      host: "mytestserver1.com",
      createdAt: "2023-04-15T21:19:35.417+00:00",
    },
    {
      path: "/login",
      host: "mytestserver1.com",
      createdAt: "2023-04-15T21:19:35.417+00:00",
    },
    {
      path: "/users",
      host: "mytestserver1.com",
      createdAt: "2023-04-14T14:19:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-14T14:19:35.417+00:00",
    },
    {
      path: "/login",
      host: "mytestserver1.com",
      createdAt: "2023-04-03T23:15:35.417+00:00",
    },
    {
      path: "/mypage",
      host: "mytestserver1.com",
      createdAt: "2023-04-03T23:37:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-03T23:38:35.417+00:00",
    },
    {
      path: "/login",
      host: "mytestserver1.com",
      createdAt: "2023-04-04T09:37:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-06T03:13:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-06T08:37:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-06T08:43:35.417+00:00",
    },
    {
      path: "/signup",
      host: "mytestserver1.com",
      createdAt: "2023-04-06T09:12:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-06T13:31:35.417+00:00",
    },
    {
      path: "/mypage",
      host: "mytestserver1.com",
      createdAt: "2023-04-07T12:12:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-08T10:12:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-08T10:55:35.417+00:00",
    },
    {
      path: "/login",
      host: "mytestserver1.com",
      createdAt: "2023-04-08T12:37:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-08T15:37:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-08T17:37:35.417+00:00",
    },
    {
      path: "/login",
      host: "mytestserver1.com",
      createdAt: "2023-04-08T17:43:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-08T19:11:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-08T20:01:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-08T20:37:35.417+00:00",
    },
    {
      path: "/signup",
      host: "mytestserver1.com",
      createdAt: "2023-04-08T20:43:35.417+00:00",
    },
    {
      path: "/login",
      host: "mytestserver1.com",
      createdAt: "2023-04-08T21:02:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-08T23:37:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-09T10:37:35.417+00:00",
    },
    {
      path: "/mypage",
      host: "mytestserver1.com",
      createdAt: "2023-04-09T10:55:35.417+00:00",
    },
    {
      path: "/logout",
      host: "mytestserver1.com",
      createdAt: "2023-04-09T13:37:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-10T20:37:35.417+00:00",
    },
    {
      path: "/login",
      host: "mytestserver1.com",
      createdAt: "2023-04-10T20:51:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-10T21:37:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-10T22:05:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-11T07:13:35.417+00:00",
    },
    {
      path: "/login",
      host: "mytestserver1.com",
      createdAt: "2023-04-11T07:17:35.417+00:00",
    },
    {
      path: "/logout",
      host: "mytestserver1.com",
      createdAt: "2023-04-11T09:27:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-11T17:13:35.417+00:00",
    },
    {
      path: "/mypage",
      host: "mytestserver1.com",
      createdAt: "2023-04-11T18:13:35.417+00:00",
    },
    {
      path: "/22",
      host: "mytestserver1.com",
      createdAt: "2023-04-11T21:13:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-12T08:15:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-12T09:13:35.417+00:00",
    },
    {
      path: "/21",
      host: "mytestserver1.com",
      createdAt: "2023-04-13T09:13:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-17T07:13:35.417+00:00",
    },
    {
      path: "/signup",
      host: "mytestserver1.com",
      createdAt: "2023-04-17T07:22:35.417+00:00",
    },
    {
      path: "/login",
      host: "mytestserver1.com",
      createdAt: "2023-04-17T07:25:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-17T08:13:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-17T09:13:35.417+00:00",
    },
    {
      path: "/mypage",
      host: "mytestserver1.com",
      createdAt: "2023-04-17T09:17:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-17T20:13:35.417+00:00",
    },
    {
      path: "/logout",
      host: "mytestserver1.com",
      createdAt: "2023-04-17T21:13:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-17T22:13:35.417+00:00",
    },
    {
      path: "/signup",
      host: "mytestserver1.com",
      createdAt: "2023-04-17T22:14:35.417+00:00",
    },
    {
      path: "/login",
      host: "mytestserver1.com",
      createdAt: "2023-04-17T22:20:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-17T23:13:35.417+00:00",
    },
    {
      path: "/22",
      host: "mytestserver1.com",
      createdAt: "2023-04-20T06:13:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-20T18:13:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-23T07:13:35.417+00:00",
    },
    {
      path: "/login",
      host: "mytestserver1.com",
      createdAt: "2023-04-23T08:13:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-23T08:17:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-23T08:42:35.417+00:00",
    },
    {
      path: "/logout",
      host: "mytestserver1.com",
      createdAt: "2023-04-23T09:03:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-24T08:13:35.417+00:00",
    },
    {
      path: "/22",
      host: "mytestserver1.com",
      createdAt: "2023-04-25T10:13:35.417+00:00",
    },
    {
      path: "/mypage",
      host: "mytestserver1.com",
      createdAt: "2023-04-25T11:13:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-25T08:19:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-27T14:13:35.417+00:00",
    },
    {
      path: "/login",
      host: "mytestserver1.com",
      createdAt: "2023-04-27T14:22:35.417+00:00",
    },
    {
      path: "/logout",
      host: "mytestserver1.com",
      createdAt: "2023-04-27T17:13:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-28T12:13:35.417+00:00",
    },
    {
      path: "/13",
      host: "mytestserver1.com",
      createdAt: "2023-04-28T16:13:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-28T16:25:35.417+00:00",
    },
    {
      path: "/mypage",
      host: "mytestserver1.com",
      createdAt: "2023-04-28T19:13:35.417+00:00",
    },
    {
      path: "/logout",
      host: "mytestserver1.com",
      createdAt: "2023-04-28T20:13:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-23T19:13:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-03-31T08:12:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-08T10:12:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-03-19T18:12:35.417+00:00",
    },
    {
      path: "/mypage",
      host: "mytestserver1.com",
      createdAt: "2023-04-02T17:12:35.417+00:00",
    },
    {
      path: "/login",
      host: "mytestserver1.com",
      createdAt: "2023-04-08T23:12:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-11T20:12:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-11T21:12:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-12T07:12:35.417+00:00",
    },
    {
      path: "/login",
      host: "mytestserver1.com",
      createdAt: "2023-03-20T05:12:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-03-20T13:12:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-03-19T14:12:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-03-21T16:12:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-03-22T06:12:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-03-22T07:00:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-03-22T03:0:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-03-23T05:04:35.417+00:00",
    },
    {
      path: "/login",
      host: "mytestserver1.com",
      createdAt: "2023-03-23T11:10:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-03-23T17:33:35.417+00:00",
    },
    {
      path: "/mypage",
      host: "mytestserver1.com",
      createdAt: "2023-03-23T17:00:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-03-26T05:05:35.417+00:00",
    },
    {
      path: "/login",
      host: "mytestserver1.com",
      createdAt: "2023-03-18T19:10:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-03-18T20:33:35.417+00:00",
    },
    {
      path: "/mypage",
      host: "mytestserver1.com",
      createdAt: "2023-03-18T20:00:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-03-18T22:05:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-03-18T21:05:35.417+00:00",
    },
    {
      path: "/logout",
      host: "mytestserver1.com",
      createdAt: "2023-03-18T23:05:35.417+00:00",
    },
    {
      path: "/13",
      host: "mytestserver1.com",
      createdAt: "2023-03-31T19:05:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-03-30T13:55:35.417+00:00",
    },
    {
      path: "/login",
      host: "mytestserver1.com",
      createdAt: "2023-04-01T00:15:35.417+00:00",
    },
    {
      path: "/22",
      host: "mytestserver1.com",
      createdAt: "2023-04-01T00:33:35.417+00:00",
    },
    {
      path: "/mypage",
      host: "mytestserver1.com",
      createdAt: "2023-04-01T01:15:35.417+00:00",
    },
    {
      path: "/login",
      host: "mytestserver1.com",
      createdAt: "2023-04-01T23:15:35.417+00:00",
    },
    {
      path: "/signup",
      host: "mytestserver1.com",
      createdAt: "2023-04-01T17:15:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-01T14:15:35.417+00:00",
    },
    {
      path: "/login",
      host: "mytestserver1.com",
      createdAt: "2023-04-03T23:15:35.417+00:00",
    },
    {
      path: "/22",
      host: "mytestserver1.com",
      createdAt: "2023-03-18T01:15:35.417+00:00",
    },
    {
      path: "/signup",
      host: "mytestserver1.com",
      createdAt: "2023-04-05T02:15:35.417+00:00",
    },
    {
      path: "/22",
      host: "mytestserver1.com",
      createdAt: "2023-03-25T06:33:35.417+00:00",
    },
    {
      path: "/mypage",
      host: "mytestserver1.com",
      createdAt: "2023-04-08T01:15:35.417+00:00",
    },
    {
      path: "/login",
      host: "mytestserver1.com",
      createdAt: "2023-04-08T03:15:35.417+00:00",
    },
    {
      path: "/signup",
      host: "mytestserver1.com",
      createdAt: "2023-04-010T04:15:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-01T17:15:35.417+00:00",
    },
    {
      path: "/login",
      host: "mytestserver1.com",
      createdAt: "2023-03-31T22:15:35.417+00:00",
    },
    {
      path: "/22",
      host: "mytestserver1.com",
      createdAt: "2023-04-01T07:15:35.417+00:00",
    },
    {
      path: "/signup",
      host: "mytestserver1.com",
      createdAt: "2023-04-08T05:15:35.417+00:00",
    },
    {
      path: "/entry",
      host: "mytestserver1.com",
      createdAt: "2023-04-08T09:15:35.417+00:00",
    },
    {
      path: "/docs",
      host: "mytestserver1.com",
      createdAt: "2023-04-07T23:15:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-07T23:15:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-03-17T06:15:35.417+00:00",
    },
    {
      path: "/users",
      host: "mytestserver1.com",
      createdAt: "2023-04-02T04:15:35.417+00:00",
    },
    {
      path: "/login",
      host: "mytestserver1.com",
      createdAt: "2023-04-02T04:15:35.417+00:00",
    },
    {
      path: "/",
      host: "mytestserver1.com",
      createdAt: "2023-04-08T08:15:35.417+00:00",
    },
  ],
  errorLists: [
    {
      _id: "1",
      path: "/entry",
      host: "mytestserver1.com",
      errorName: "Error",
      errorMessage: "Not Found",
      errorStack:
        "Error: Not Found\n    at /Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/app.js:56:15\n    at Layer.handle [as handle_request] (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/layer.js:95:5)\n    at trim_prefix (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/index.js:328:13)\n    at /Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/index.js:286:9\n    at Function.process_params (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/index.js:346:12)\n    at next (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/index.js:280:10)\n    at SendStream.error (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/serve-static/index.js:121:7)\n    at SendStream.emit (node:events:513:28)\n    at SendStream.error (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/send/index.js:270:17)\n    at SendStream.onStatError (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/send/index.js:417:12)",
      createdAt: "2023-04-14T13:19:56.862Z",
    },
    {
      _id: "2",
      path: "/votings/votings/new",
      host: "mytestserver1.com",
      errorName: "Error",
      errorMessage: "Not Found",
      errorStack:
        "Error: Not Found\n    at /Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/app.js:56:15\n    at Layer.handle [as handle_request] (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/layer.js:95:5)\n    at trim_prefix (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/index.js:328:13)\n    at /Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/index.js:286:9\n    at Function.process_params (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/index.js:346:12)\n    at next (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/index.js:280:10)\n    at SendStream.error (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/serve-static/index.js:121:7)\n    at SendStream.emit (node:events:513:28)\n    at SendStream.error (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/send/index.js:270:17)\n    at SendStream.onStatError (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/send/index.js:417:12)",
      createdAt: "2023-04-14T13:24:00.427Z",
    },
    {
      _id: "3",
      path: "/votings/new",
      host: "mytestserver1.com",
      errorName: "TypeError",
      errorMessage: "optionList is not iterable",
      errorStack:
        "TypeError: optionList is not iterable\n    at saveOptionInform (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/routes/middlewares/updateData.js:27:24)\n    at Layer.handle [as handle_request] (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/layer.js:95:5)\n    at next (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/route.js:144:13)\n    at Route.dispatch (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/route.js:114:3)\n    at Layer.handle [as handle_request] (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/layer.js:95:5)\n    at /Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/index.js:284:15\n    at Function.process_params (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/index.js:346:12)\n    at next (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/index.js:280:10)\n    at Function.handle (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/index.js:175:3)\n    at router (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/index.js:47:12)",
      createdAt: "2023-04-14T13:24:28.777Z",
    },
    {
      _id: "4",
      path: "/votings/new",
      host: "mytestserver1.com",
      errorName: "TypeError",
      errorMessage: "optionList is not iterable",
      errorStack:
        "TypeError: optionList is not iterable\n    at saveOptionInform (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/routes/middlewares/updateData.js:27:24)\n    at Layer.handle [as handle_request] (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/layer.js:95:5)\n    at next (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/route.js:144:13)\n    at Route.dispatch (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/route.js:114:3)\n    at Layer.handle [as handle_request] (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/layer.js:95:5)\n    at /Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/index.js:284:15\n    at Function.process_params (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/index.js:346:12)\n    at next (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/index.js:280:10)\n    at Function.handle (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/index.js:175:3)\n    at router (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/index.js:47:12)",
      createdAt: "2023-04-14T13:25:22.118Z",
    },
    {
      _id: "5",
      path: "/docsw",
      host: "mytestserver1.com",
      errorName: "Error",
      errorMessage: "Not Found",
      errorStack:
        "Error: Not Found\n    at /Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w06/app.js:48:15\n    at Layer.handle [as handle_request] (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w06/node_modules/express/lib/router/layer.js:95:5)\n    at trim_prefix (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w06/node_modules/express/lib/router/index.js:323:13)\n    at /Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w06/node_modules/express/lib/router/index.js:284:7\n    at Function.process_params (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w06/node_modules/express/lib/router/index.js:341:12)\n    at next (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w06/node_modules/express/lib/router/index.js:275:10)\n    at serveStatic (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w06/node_modules/serve-static/index.js:75:16)\n    at Layer.handle [as handle_request] (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w06/node_modules/express/lib/router/layer.js:95:5)\n    at trim_prefix (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w06/node_modules/express/lib/router/index.js:323:13)\n    at /Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w06/node_modules/express/lib/router/index.js:284:7",
      createdAt: "2023-04-15T03:36:43.441Z",
    },
    {
      _id: "6",
      path: "/my-votings",
      host: "mytestserver1.com",
      errorName: "Error",
      errorMessage: "Not Found",
      errorStack:
        "Error: Not Found\n    at /Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w06/app.js:48:15\n    at Layer.handle [as handle_request] (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w06/node_modules/express/lib/router/layer.js:95:5)\n    at trim_prefix (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w06/node_modules/express/lib/router/index.js:323:13)\n    at /Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w06/node_modules/express/lib/router/index.js:284:7\n    at Function.process_params (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w06/node_modules/express/lib/router/index.js:341:12)\n    at next (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w06/node_modules/express/lib/router/index.js:275:10)\n    at serveStatic (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w06/node_modules/serve-static/index.js:75:16)\n    at Layer.handle [as handle_request] (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w06/node_modules/express/lib/router/layer.js:95:5)\n    at trim_prefix (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w06/node_modules/express/lib/router/index.js:323:13)\n    at /Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w06/node_modules/express/lib/router/index.js:284:7",
      createdAt: "2023-04-16T16:36:29.294Z",
    },
    {
      _id: "7",
      path: "/my-votings",
      host: "mytestserver1.com",
      errorName: "Error",
      errorMessage: "Not Found",
      errorStack:
        "Error: Not Found\n    at /Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w06/app.js:48:15\n    at Layer.handle [as handle_request] (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w06/node_modules/express/lib/router/layer.js:95:5)\n    at trim_prefix (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w06/node_modules/express/lib/router/index.js:323:13)\n    at /Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w06/node_modules/express/lib/router/index.js:284:7\n    at Function.process_params (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w06/node_modules/express/lib/router/index.js:341:12)\n    at next (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w06/node_modules/express/lib/router/index.js:275:10)\n    at serveStatic (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w06/node_modules/serve-static/index.js:75:16)\n    at Layer.handle [as handle_request] (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w06/node_modules/express/lib/router/layer.js:95:5)\n    at trim_prefix (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w06/node_modules/express/lib/router/index.js:323:13)\n    at /Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w06/node_modules/express/lib/router/index.js:284:7",
      createdAt: "2023-04-18T13:42:29.294Z",
    },
    {
      _id: "8",
      path: "/votings/new",
      host: "mytestserver1.com",
      errorName: "Error",
      errorMessage: "optionList is not iterable",
      errorStack:
        "TypeError: optionList is not iterable\n    at saveOptionInform (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/routes/middlewares/updateData.js:27:24)\n    at Layer.handle [as handle_request] (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/layer.js:95:5)\n    at next (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/route.js:144:13)\n    at Route.dispatch (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/route.js:114:3)\n    at Layer.handle [as handle_request] (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/layer.js:95:5)\n    at /Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/index.js:284:15\n    at Function.process_params (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/index.js:346:12)\n    at next (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/index.js:280:10)\n    at Function.handle (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/index.js:175:3)\n    at router (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/index.js:47:12)",
      createdAt: "2023-04-17T22:24:28.777Z",
    },
    {
      _id: "9",
      path: "/votings/new",
      host: "mytestserver1.com",
      errorName: "TypeError",
      errorMessage: "optionList is not iterable",
      errorStack:
        "TypeError: optionList is not iterable\n    at saveOptionInform (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/routes/middlewares/updateData.js:27:24)\n    at Layer.handle [as handle_request] (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/layer.js:95:5)\n    at next (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/route.js:144:13)\n    at Route.dispatch (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/route.js:114:3)\n    at Layer.handle [as handle_request] (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/layer.js:95:5)\n    at /Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/index.js:284:15\n    at Function.process_params (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/index.js:346:12)\n    at next (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/index.js:280:10)\n    at Function.handle (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/index.js:175:3)\n    at router (/Users/igeonhwa/Desktop/bootcamp14/bootcamp14-w07/node_modules/express/lib/router/index.js:47:12)",
      createdAt: "2023-04-17T13:24:28.777Z",
    },
  ],
  selectDate: null,
};

export default MockData;
